import React from "react";
import { Divider } from "antd";

import "./categories.scss";
import "./import-installed-widget.scss"

import { TCategory } from "./constants";
import { ReactComponent as SearchIcon } from "../../../../assets/svg/searchIconWithBg.svg";

interface ICategoriesProps {
  onClick: (value: TCategory) => void;
  allCatagories: TCategory[];
  activeTab: TCategory;
}

const Categories: React.FC<ICategoriesProps> = ({
  onClick,
  allCatagories,
  activeTab,
}) => {
  return (
    <>
      <div className="tabs-active">
        {allCatagories.map((category, index) => (
          <button
            data-test-id={`categories_${category}`}
            key={index}
            className={`tab ${category === activeTab ? "active" : ""}`}
            onClick={() => onClick(category)}
          >
            {category}
          </button>
        ))}
        <div className="right">
          <SearchIcon data-test-id="search_icon" width="25px" height="25px" />
        </div>
      </div>
      <Divider style={{ margin: "10px 0" }} />
    </>
  );
};

export default Categories;
